(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22734],{

/***/ 86271:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/services",
      function () {
        return __webpack_require__(92850);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ Layout; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../brand/components/index.ts + 163 modules
var components = __webpack_require__(46731);
// EXTERNAL MODULE: ./src/components/organisms/index.ts + 50 modules
var organisms = __webpack_require__(79427);
// EXTERNAL MODULE: ./src/hooks/index.ts + 17 modules
var hooks = __webpack_require__(55102);
// EXTERNAL MODULE: ./src/helpers/getQueryVariable.ts
var getQueryVariable = __webpack_require__(35617);
;// CONCATENATED MODULE: ./src/components/layouts/Layout.tsx








var Layout = function(_param) {
    var _hasHeader = _param.hasHeader, hasHeader = _hasHeader === void 0 ? true : _hasHeader, _isMenuSticky = _param.isMenuSticky, isMenuSticky = _isMenuSticky === void 0 ? true : _isMenuSticky, props = (0,_object_without_properties/* default */.Z)(_param, [
        "hasHeader",
        "isMenuSticky"
    ]);
    var locale = (0,hooks/* useTranslation */.$G)().locale;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        router.events.on("routeChangeStart", function() {
            setIsOpen(false);
        });
        return function() {
            setIsOpen(false);
        };
    }, []);
    (0,react.useEffect)(function() {
        var html = document.querySelector("html");
        if (html) html.lang = locale;
    }, [
        locale
    ]);
    (0,react.useEffect)(function() {
        (0,getQueryVariable/* saveMarketingData */.L)();
    }, []);
    var renderHeader = function() {
        if (hasHeader) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* MenuMobile */.XN, {
                        alternativeLinks: props.alternativeLinks || []
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* MenuDesktop */.WA, {
                        alternativeLinks: props.alternativeLinks,
                        isOpen: isOpen,
                        setIsOpen: setIsOpen,
                        isSticky: isMenuSticky,
                        hasCta: props.hasCta
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    };
    var renderFooter = function() {
        switch(props.hasFooter){
            case "none":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
            default:
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(organisms/* Footer */.$_, {});
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Box */.xu, {
        as: "section",
        children: [
            renderHeader(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
                role: "main",
                children: props.children
            }),
            renderFooter()
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/layouts/index.ts



/***/ }),

/***/ 59288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ HomePreFooter; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52903);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _brand_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46731);
/* harmony import */ var _hoa_atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97347);
/* harmony import */ var _hoa_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55102);





var HomePreFooter = function() {
    var t = (0,_hoa_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        as: "section",
        pt: 20,
        pb: 32,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                align: "center",
                justify: "center",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                        as: "h3",
                        variant: "h4",
                        textAlign: "center",
                        mb: 10,
                        children: t("home:preFooter.title")
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_hoa_atoms__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                        href: "/categories",
                        anchorProps: {
                            fontSize: "md",
                            _hover: {
                                textDecoration: "none"
                            }
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                            size: "md",
                            variant: "solid",
                            children: t("home:hero:action")
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 35617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ saveMarketingData; }
/* harmony export */ });
/* unused harmony export getQueryVariable */
/* harmony import */ var _hoa_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88731);
// @ts-nocheck

var getQueryVariable = function(variable) {
    var search = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var query = search.substring(1);
    var vars = query.split("&");
    for(var i = 0; i < vars.length; i += 1){
        var pair = vars[i].split("=");
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
};
var saveMarketingData = function() {
    var utmParameters = {
        utmSource: getQueryVariable("utm_source", window.location.search),
        utmCampaign: getQueryVariable("utm_campaign", window.location.search),
        utmMedium: getQueryVariable("utm_medium", window.location.search),
        utmPage: getQueryVariable("utm_page", window.location.search)
    };
    //Disabled since utmsource 'organic' was not correct
    // if (!sessionStorage.getItem(LocalStorage.UTM_PARAMETERS)) {
    //   utmParameters.utmSource =
    //     !utmParameters.utmSource &&
    //     document &&
    //     document.referrer &&
    //     document.referrer.includes('google')
    //       ? 'organic'
    //       : utmParameters.utmSource;
    // }
    if (utmParameters.utmSource) {
        sessionStorage.setItem(_hoa_config__WEBPACK_IMPORTED_MODULE_0__/* .LocalStorage.UTM_PARAMETERS */ .mM.UTM_PARAMETERS, JSON.stringify(utmParameters));
    }
    if (sessionStorage.getItem(_hoa_config__WEBPACK_IMPORTED_MODULE_0__/* .LocalStorage.GCLID_PARAMETERS */ .mM.GCLID_PARAMETERS) === null && getQueryVariable("gclid", window.location.search) !== null) {
        sessionStorage.setItem(_hoa_config__WEBPACK_IMPORTED_MODULE_0__/* .LocalStorage.GCLID_PARAMETERS */ .mM.GCLID_PARAMETERS, getQueryVariable("gclid", window.location.search));
    }
};


/***/ }),

/***/ 92850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Offers": function() { return /* binding */ Offers; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52903);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _brand_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46731);
/* harmony import */ var _hoa_atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97347);
/* harmony import */ var _hoa_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55102);
/* harmony import */ var _hoa_layouts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25356);
/* harmony import */ var _hoa_components_molecules__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11917);
/* harmony import */ var _hoa_components_pages_Home_HomePreFooter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59288);
/* harmony import */ var _hoa_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98007);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28165);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52091);
/* harmony import */ var react_icons_fa6__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86204);















var __N_SSG = true;
var Offers = function() {
    var ref = (0,_hoa_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)(), locales = ref.locales, t = ref.t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var expandedIndexRFQ = router.query.query === t("common:generic.quote") ? [
        0
    ] : 99;
    var expandedIndexIR = router.query.query === t("common:generic.fixedPrice") ? [
        0
    ] : 99;
    var IRref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var RFQref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timer1 = function() {
            return setTimeout(function() {
                (0,_hoa_utils__WEBPACK_IMPORTED_MODULE_7__/* .scrollToElement */ .kI)(IRref.current, 0);
            }, 1000);
        };
        if (router.query.query === t("common:generic.fixedPrice")) {
            timer1();
        }
        var timer2 = function() {
            return setTimeout(function() {
                (0,_hoa_utils__WEBPACK_IMPORTED_MODULE_7__/* .scrollToElement */ .kI)(RFQref.current, 0);
            }, 1000);
        };
        if (router.query.query === t("common:generic.quote")) {
            timer2();
        }
        return function() {
            clearTimeout(timer1());
            clearTimeout(timer2());
        };
    }, [
        router.query
    ]);
    var alternativeLinks = locales.map(function(locale) {
        return {
            locale: locale,
            path: ""
        };
    });
    var handleAccordionIROpen = function() {
        (0,_hoa_utils__WEBPACK_IMPORTED_MODULE_7__/* .scrollToElement */ .kI)(IRref.current, 0);
    };
    var handleAccordionRfqOpen = function() {
        (0,_hoa_utils__WEBPACK_IMPORTED_MODULE_7__/* .scrollToElement */ .kI)(RFQref.current, 0);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_hoa_atoms__WEBPACK_IMPORTED_MODULE_2__/* .Seo */ .pQ, {
                title: t("offers:seo.title"),
                description: t("offers:seo.description"),
                indexed: false
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_hoa_layouts__WEBPACK_IMPORTED_MODULE_4__/* .Layout */ .A, {
                alternativeLinks: alternativeLinks,
                hasHeader: true,
                hasFooter: "small",
                isMenuSticky: true,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        as: "section",
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                position: "absolute",
                                width: "100vw",
                                h: "100%",
                                zIndex: -2,
                                overflow: "hidden",
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)("clip-path:polygon(0 0,100% 0,100% 82%,0 92%);"),
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_hoa_atoms__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, {
                                    loader: _hoa_utils__WEBPACK_IMPORTED_MODULE_7__/* .cloudfrontLoader */ .kv,
                                    src: "/images/hero-images/jaimy_hero_renovation.jpg",
                                    alt: "Jaimy homepage hero image",
                                    layout: "fill",
                                    objectFit: "cover",
                                    objectPosition: "50% 20%",
                                    quality: 60
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    align: "center",
                                    justifyContent: "spaceBetween",
                                    pb: [
                                        "65px",
                                        "150px",
                                        "175px",
                                        null
                                    ],
                                    pt: [
                                        "40px",
                                        "125px",
                                        "150px",
                                        null
                                    ],
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                        bg: "rgba(255, 255, 255, 0.8)",
                                        borderRadius: "3xl",
                                        textAlign: "center",
                                        py: [
                                            4,
                                            6,
                                            6,
                                            null,
                                            6
                                        ],
                                        px: [
                                            4,
                                            6,
                                            10,
                                            null,
                                            "100px"
                                        ],
                                        m: "0 auto",
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                                                    as: "h1",
                                                    variant: "h2",
                                                    color: "primary.base",
                                                    m: 2,
                                                    mb: [
                                                        6,
                                                        8,
                                                        null,
                                                        null
                                                    ],
                                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_hoa_atoms__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                                                        i18nKey: "common:generic.ourOffers"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                size: "lg",
                                                as: "h2",
                                                fontWeight: 500,
                                                fontStyle: "italic",
                                                mb: [
                                                    6,
                                                    8,
                                                    null,
                                                    null
                                                ],
                                                children: t("home:hero.subtitle")
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        py: 4,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                px: [
                                    2,
                                    4,
                                    6
                                ],
                                as: "section",
                                position: "relative",
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                        pt: [
                                            2,
                                            null,
                                            16
                                        ],
                                        pb: [
                                            4,
                                            null,
                                            8
                                        ],
                                        bg: "white",
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                align: "center",
                                                justify: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                        p: [
                                                            2,
                                                            4,
                                                            null,
                                                            null
                                                        ],
                                                        onClick: handleAccordionIROpen,
                                                        children: t("common:generic.fixedPrice")
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                        m: 6,
                                                        children: t("common:generic.or")
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                                        p: [
                                                            2,
                                                            4,
                                                            null,
                                                            null
                                                        ],
                                                        onClick: handleAccordionRfqOpen,
                                                        variant: "solidBlue",
                                                        children: t("common:generic.quoteSr")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                align: "center",
                                                justify: "center",
                                                m: [
                                                    4,
                                                    null,
                                                    6
                                                ],
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                                                    as: "h2",
                                                    variant: "h4",
                                                    textAlign: "center",
                                                    children: t("offers:generic.subtitle")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                        py: [
                                            4,
                                            6,
                                            8
                                        ],
                                        px: [
                                            6,
                                            null,
                                            8
                                        ],
                                        bg: "gray.100",
                                        borderRadius: "10px 10px 0px 0px",
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                            align: "flex-start",
                                            justify: "center",
                                            direction: "column",
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                align: "center",
                                                justify: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_hoa_components_molecules__WEBPACK_IMPORTED_MODULE_5__/* .IconBox */ .zb, {
                                                        size: "md",
                                                        icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaCheckCircle */ .FJM, {
                                                            color: "white"
                                                        }),
                                                        background: "heading",
                                                        padding: "10px",
                                                        mr: 4
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                            size: "lg",
                                                            children: t("offers:content.first")
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                        py: [
                                            4,
                                            6,
                                            8
                                        ],
                                        px: [
                                            6,
                                            null,
                                            8
                                        ],
                                        bg: "gray.200",
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                            align: "flex-start",
                                            justify: "center",
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                    align: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_hoa_components_molecules__WEBPACK_IMPORTED_MODULE_5__/* .IconBox */ .zb, {
                                                            size: "md",
                                                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaWrench */ .LDL, {
                                                                color: "white"
                                                            }),
                                                            background: "heading",
                                                            padding: "10px",
                                                            mr: 4
                                                        }),
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_hoa_atoms__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                                                            i18nKey: "offers:content.second",
                                                            components: {
                                                                p: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                    size: "lg"
                                                                }),
                                                                span: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("button", {
                                                                    style: {
                                                                        color: "hsl(354, 81%, 42%)",
                                                                        fontWeight: "bold"
                                                                    }
                                                                })
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Accordion */ .UQ, {
                                                    defaultIndex: expandedIndexIR || 99,
                                                    width: "100%",
                                                    p: [
                                                        1,
                                                        2,
                                                        4
                                                    ],
                                                    mx: [
                                                        1,
                                                        2,
                                                        4
                                                    ],
                                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qd, {
                                                        ref: IRref,
                                                        bg: "gray.200",
                                                        width: "100%",
                                                        children: [
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KF, {
                                                                fontStyle: "italic",
                                                                color: "heading",
                                                                borderRadius: "10px",
                                                                borderColor: "gray.200",
                                                                mt: 2,
                                                                p: 1,
                                                                bg: "gray.300",
                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                    size: "md",
                                                                    children: t("offers:generic.howDoesItWork")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .AccordionPanel */ .Hk, {
                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .List */ .aV, {
                                                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                                        align: "flex-start",
                                                                        justify: "center",
                                                                        direction: "column",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC, {
                                                                                p: [
                                                                                    1,
                                                                                    1,
                                                                                    2
                                                                                ],
                                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                                                    direction: "column",
                                                                                    align: "flex-start",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                                                            direction: "row",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaCheckCircle */ .FJM, {}),
                                                                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                                    size: "lg",
                                                                                                    ml: [
                                                                                                        1,
                                                                                                        2,
                                                                                                        4
                                                                                                    ],
                                                                                                    children: t("offers:content.accordionOne")
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                                size: "md",
                                                                                                fontStyle: "italic",
                                                                                                children: t("offers:content.accordionOneSub")
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC, {
                                                                                p: [
                                                                                    1,
                                                                                    1,
                                                                                    2
                                                                                ],
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaCheckCircle */ .FJM, {}),
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                        size: "lg",
                                                                                        ml: [
                                                                                            1,
                                                                                            2,
                                                                                            4
                                                                                        ],
                                                                                        children: t("offers:content.accordionTwo")
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC, {
                                                                                p: [
                                                                                    1,
                                                                                    1,
                                                                                    2
                                                                                ],
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaCheckCircle */ .FJM, {}),
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                        size: "lg",
                                                                                        ml: [
                                                                                            1,
                                                                                            2,
                                                                                            4
                                                                                        ],
                                                                                        children: t("offers:content.accordionThree")
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC, {
                                                                                p: [
                                                                                    1,
                                                                                    1,
                                                                                    2
                                                                                ],
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaCheckCircle */ .FJM, {}),
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                        size: "lg",
                                                                                        ml: [
                                                                                            1,
                                                                                            2,
                                                                                            4
                                                                                        ],
                                                                                        children: t("offers:content.accordionFour")
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                        py: [
                                            4,
                                            6,
                                            8
                                        ],
                                        px: [
                                            6,
                                            null,
                                            8
                                        ],
                                        bg: "gray.100",
                                        borderRadius: "0px 0px 10px 10px",
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                            align: "flex-start",
                                            justify: "center",
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                    align: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_hoa_components_molecules__WEBPACK_IMPORTED_MODULE_5__/* .IconBox */ .zb, {
                                                            size: "md",
                                                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa6__WEBPACK_IMPORTED_MODULE_12__/* .FaHouse */ .QBi, {
                                                                color: "white"
                                                            }),
                                                            background: "heading",
                                                            padding: "10px",
                                                            mr: 4
                                                        }),
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_hoa_atoms__WEBPACK_IMPORTED_MODULE_2__/* .Trans */ .cC, {
                                                            i18nKey: "offers:content.third",
                                                            components: {
                                                                p: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                    size: "lg"
                                                                }),
                                                                span: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("button", {
                                                                    style: {
                                                                        color: "hsl(354, 81%, 42%)",
                                                                        fontWeight: "bold"
                                                                    }
                                                                })
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Accordion */ .UQ, {
                                                    defaultIndex: expandedIndexRFQ || 99,
                                                    width: "100%",
                                                    p: [
                                                        1,
                                                        2,
                                                        6
                                                    ],
                                                    mx: [
                                                        1,
                                                        2,
                                                        4
                                                    ],
                                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .AccordionItem */ .Qd, {
                                                        ref: RFQref,
                                                        bg: "gray.100",
                                                        width: "100%",
                                                        children: [
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .AccordionButton */ .KF, {
                                                                width: "100%",
                                                                fontStyle: "italic",
                                                                mt: 2,
                                                                p: 1,
                                                                borderRadius: "10px",
                                                                bg: "gray.300",
                                                                marginLeft: "0 auto",
                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                    textAlign: "left",
                                                                    size: "md",
                                                                    children: t("offers:generic.howDoesItWork")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .AccordionPanel */ .Hk, {
                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .List */ .aV, {
                                                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                                        align: "flex-start",
                                                                        justify: "center",
                                                                        direction: "column",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC, {
                                                                                p: 2,
                                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                                                    direction: "column",
                                                                                    align: "center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaCheckCircle */ .FJM, {}),
                                                                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                                    size: "lg",
                                                                                                    ml: [
                                                                                                        1,
                                                                                                        2,
                                                                                                        4
                                                                                                    ],
                                                                                                    children: t("offers:content.accordionFive")
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                                size: "md",
                                                                                                fontStyle: "italic",
                                                                                                children: t("offers:content.accordionFiveSub")
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC, {
                                                                                p: 2,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaCheckCircle */ .FJM, {
                                                                                        size: 22
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                        size: "lg",
                                                                                        ml: [
                                                                                            1,
                                                                                            2,
                                                                                            4
                                                                                        ],
                                                                                        children: t("offers:content.accordionSix")
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC, {
                                                                                p: 2,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaCheckCircle */ .FJM, {}),
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                        size: "lg",
                                                                                        ml: [
                                                                                            1,
                                                                                            2,
                                                                                            4
                                                                                        ],
                                                                                        children: t("offers:content.accordionSeven")
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC, {
                                                                                p: 2,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaCheckCircle */ .FJM, {}),
                                                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                        size: "lg",
                                                                                        ml: [
                                                                                            1,
                                                                                            2,
                                                                                            4
                                                                                        ],
                                                                                        children: t("offers:content.accordionEight")
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_hoa_components_pages_Home_HomePreFooter__WEBPACK_IMPORTED_MODULE_6__/* .HomePreFooter */ .H, {})
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Offers);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [34396,49774,92888,40179], function() { return __webpack_exec__(86271); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);